import UrlUtilities from '@shared/common/UrlUtilities';
import BaseService from '@shared/services/BaseService';

var url = `${UrlUtilities.getApiUrl()}/LicenseApi/api/license`;

var LicenseServices = {
    ...BaseService,

    getLicenseInfo: function (successCallback: any, errorCallback: any, ignoreDefaultError?: boolean) {
        this.get(`${url}/Get`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },

    getAllLicenses: function (successCallback: any, errorCallback: any, ignoreDefaultError?: boolean) {
        this.get(`${url}/GetAll`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },

    createLicense: function (licenseKey: string, successCallback: any, errorCallback: any) {
        this.post(`${url}/Create`,
            { key: licenseKey },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    }
};

export default LicenseServices;
